import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {artifactRegistryAppBuilder} from './config/app-builder'

import {artifactRegistryIndexRoute, artifactRegistryShowRoute} from './routes/artifact-registry-route'
import {ArtifactRegistryIndex} from './routes/ArtifactRegistryIndex'
import {ArtifactRegistryShow} from './routes/ArtifactRegistryShow'

export const artifactRegistryApp = artifactRegistryAppBuilder.createDataRouterAppFromRoutes([
  artifactRegistryIndexRoute.toRoute({Component: ArtifactRegistryIndex}),
  artifactRegistryShowRoute.toRoute({Component: ArtifactRegistryShow}),
])
registerDataRouterApp(artifactRegistryApp)
